<template>
  <div class="priceboost priceboost--single-reversed promo-container" :style="{'background-image': `url(${scContent.FieldValues.Parameters['img_background']})`}">
    <div class="event-content">
      <div class="event-odds">
        <div class="event-odds__was">
          <span class="event-odds__value">{{ event.Event.Market.Option[priceboostSelection]['@odds'] | twoDecimalsNumber }}</span>
        </div>
        <a class="event-odds__now" :href="betSlipUrl">
          <span class="event-odds__value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>
        </a>
      </div>
      <div class="event">
        <div class="event__claim" v-html="scContent.FieldValues.Parameters['copy_claim']"></div>
        <div class="button__wrapper">
          <a v-if="!loggedin" class="button button--cta button--md" :href="registrationUrl">{{ scContent.FieldValues.Parameters['copy_cta'] }}</a>
        </div>
      </div>
      <div class="event-text" v-html="scContent.FieldValues.Text"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'scContent',
    'betSlipUrl',
    'teamShirts',
    'event',
    'eventDate',
    'priceboostSelection',
    'loggedin'
  ],
  computed: {
    siteConfig() {
      return window.siteConfig;
    },
    registrationUrl() {
      const fixedLang = this.siteConfig.language === 'es-419' ? 'es-cl' : this.siteConfig.language;
      if (this.siteConfig.isMobile === 'True' || this.siteConfig.isNative === 'True') {
        return "https://" + window.location.host.substring(6, window.location.host.length) + "/" + fixedLang + "/mobileportal/register?rurl=" + encodeURIComponent(window.location.href);
      } else {
        return `//${window.location.hostname.replace("promo", "www")}/${fixedLang}/registration?_layout=layouts%2fportaloverlaylayout&.box=1`;
      }
    },
  },
  filters: {
    twoDecimalsNumber(value) {
      const parts = value.split(".");
      if(parts[1] === undefined) return `${value}.00`;
      if(parts[1].length === 1) return `${value}0`;
      return value;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
  .priceboost--single-reversed {
    background-position: 75% center;
    background-size: cover;
    height: calc(100vh - 70px);
    padding-top: 53px;
    .event-content {
      align-items: center;
      background-color: transparent;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      margin-top: 0;
      padding-bottom: 50px;
      position: relative;
    }

    .event-odds {
      display: block;
      margin: 0;
      text-align: left;
      width: auto;
      &__was {
        font-size: 1.2rem;
        margin-bottom: 5px;
        width: auto;
        &:after {
          content: none;
        }
        .event-odds__value {
          background: #222;
          border-radius: 5px;
          padding: 5px;
          position: relative;

          &:after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background-color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      &__now {
        border: 0;
        color: #000;
        font-size: 3rem;
        width: auto;
      }
    }

    .event__claim {
      text-align: left;
      text-transform: none;
    }

    .event-text {
      background: rgba(0,0,0,.5);
      bottom: 0;
      left: 0;
      position: absolute;
      padding: 10px 20px;
      text-align: left;
      width: 100%;
    }

  }

.button__wrapper {
  background: rgba(0, 0, 0, .5);
  bottom: 0;
  left: 0;
  padding: 15px 0;
  position: fixed;
  width: 100%;

  .button {
    font-size: 16px;
    font-family: 'Roboto', Verdana, Arial, Helvetica, sans-serif;
    padding: 10px;
    display: inline-block;
  }
}

@media (min-width: 991px) {  
  .priceboost--single-reversed {
    background-position: center;
    background-size: auto;
    height: 500px;
    padding: 0;
  
    .event-content {
      flex-direction: row;
      justify-content: flex-start;
    }

    .event-odds {
      padding-left: 40px;
      width: 45%;
    }
  }

  .button__wrapper {
    background: none;
    position: relative;
  }
}
</style>
